import { Component } from '@angular/core';
import { LoadingService } from '../../../services/loading.service';
import { LearningPathModel } from 'src/app/models/learning-paths/learning-path.model';
import { PersonService } from 'src/app/services/person.service';
import { PageStateService } from 'src/app/services/page-state.service';
import { PageStateFlags } from 'src/app/constants/page-state.constants';

@Component({
  selector: 'app-learning-paths--overview',
  templateUrl: './learning-paths-overview.component.html',
  styleUrls: ['./learning-paths-overview.component.scss'],
  standalone: false
})
export class LearningPathsOverviewComponent {
  searchString: string = '';
  allLearningPaths: LearningPathModel[] = [];
  learningPaths: LearningPathModel[] = [];

  private readonly pageStateKey = 'my-learning-paths-page';

  constructor(
    private personService: PersonService,
    private loaderService: LoadingService,
    private pageStateService: PageStateService
  ) {
  }

  ngOnInit() {
    if (!this.pageStateService.consumeFlag(
      PageStateFlags.RestoreMyLearningPathsOverview
    )) {
      this.pageStateService.clear(this.pageStateKey);
    }

    this.loadMyLearningPaths();
  }

  loadMyLearningPaths() {
    this.loaderService
      .load(this.personService.getLearningPathsAssigned())
      .subscribe((learningPaths) => {
        this.allLearningPaths = learningPaths;
        this.learningPaths = learningPaths;
        this.loadPageState();
      });
  }

  onSearchInput(event: any) {
    this.searchString = event.value.toLowerCase();
    this.savePageState();

    this.searchInput();
  }

  private searchInput() {
    if (!!this.searchString) {
      this.learningPaths = this.allLearningPaths.filter((obj: LearningPathModel) => {
        const pathMatch =
          obj.name.toLowerCase().includes(this.searchString) ||
          (obj.description || '')
            .toLowerCase()
            .includes(this.searchString);

        return pathMatch;
      });
    } else {
      this.learningPaths = [...this.allLearningPaths];
    }
  } 

  private savePageState(): void {
    this.pageStateService.save(this.pageStateKey, {
      searchString: this.searchString,
    });
  }
  
  private loadPageState(): void {
    const state = this.pageStateService.load<{
      searchString: string;
    }>(this.pageStateKey);

    if (!state) return;

    this.searchString = state.searchString ?? '';
    this.searchInput();
  }
}
